<template>
    <template v-if="value && input.tableHtmlColumn">
        <div v-html="tableHtml(input.tableHtmlColumn)"></div>

    </template>
    <template v-else-if="value && input.type == 'InputPhoto'">
        <Avatar :image="`${option.file_url}/${value}`" class="flex items-center justify-start mr-2" size="xlarge" />
    </template>
    <template v-else-if="value && input.type == 'Editor'">
        <div v-html="value"></div>
    </template>
    <template v-else-if="input.type == 'Checkbox'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;">
            {{ value ? 'true' : value == 0 ? 'false' : '' }}
        </div>

    </template>
    <template v-else-if="input.type == 'Icons'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;">
            <i :class="value + ' text-2xl'"></i>
        </div>

    </template>
    <template v-else-if="input.type == 'RangePicker'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;"
            v-html="collect(value).implode('<br>')">

        </div>

    </template>
    <template v-else-if="input.type == 'DateTimePicker'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;"
            v-html="moment(value).format('YYYY-MM-DD HH:mm')">

        </div>
    </template>
    <template v-else-if="input.type == 'DatePicker'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;"
            v-html="moment(value).format('YYYY-MM-DD')">

        </div>
    </template>
    <template v-else-if="input.type == 'TimePicker'">
        <div style="display: flex;align-items: center;justify-content: start;height: 50px;"
            v-html="moment(value).format('HH:mm')">

        </div>
    </template>
    <template v-else-if="value && input.type == 'FileUpload' && input.accept == 'image'">
        <template v-if="input.multiple">
            <template v-for="file in value">
                <a :href="`${option.file_url}/${file}`" target="_blank">
                    <Avatar :image="`${option.file_url}/${file}`" class="flex items-center justify-start mr-2"
                        size="xlarge" />
                </a>
            </template>

        </template>
        <template v-else>
            <a :href="`${option.file_url}/${value}`" target="_blank">
                <Avatar :image="`${option.file_url}/${value}`" class="flex items-center justify-start mr-2"
                    size="xlarge" />
            </a>
        </template>

    </template>

    <template v-else-if="value && input.type == 'FileUpload'">
        <template v-if="input.multiple">
            <template v-for="file in value">
                <div style="display: flex;align-items: center;justify-content: start;height: 50px;">
                    <a :href="`${option.file_url}/${file}`" target="_blank" class="text-blue-500 hover:underline">
                        {{ file }}
                    </a>
                </div>
            </template>

        </template>
        <template v-else>
            <div style="display: flex;align-items: center;justify-content: start;height: 50px;">
                <a :href="`${option.file_url}/${value}`" target="_blank" class="text-blue-500 hover:underline">
                    {{ value }}
                </a>
            </div>
        </template>

    </template>


    <template v-else-if="selectValue()">
        <div style=" display: flex;align-items: center;justify-content: start;height: 50px;">
            {{ selectValue() }}
        </div>
    </template>
    <template v-else-if="input.type == 'InputCurrency'">
        <div class="currency">
            <InputNumber readonly="" :default-value="value" mode="currency" currency="TRY" locale="tr-TR" fluid />
        </div>
    </template>

    <template v-else>
        <div v-if="value && value.startsWith('http')"
            style="display: flex;align-items: center;justify-content: start;height: 50px;">
            <a :href="value" v-html="value" target="_blank"></a>
        </div>
        <div v-else style="display: flex;align-items: center;justify-content: start;height: 50px;">
            <div v-html="value"></div>
        </div>
    </template>
</template>


<script setup>




import collect from 'collect.js';
import { trans as $t, trans } from 'laravel-vue-i18n';
import moment from 'moment';

const props = defineProps(
    {
        value: {
            type: [String, Number, Boolean, Array],
            default: null
        },
        input: {
            type: Object,
            default: null
        },
        option: {
            type: Object,
            default: null
        },
        item: {
            type: Object,
            default: null
        }
    }
);

const input = props.input;
const option = props.option;


const tableHtml = (html) => {
    console.log('tableHtml', html);

    // var array = Object.keys(props.item);
    const item = props.item || {};
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Tüm data-* elemanlarını seç
    const elements = doc.querySelectorAll("[data-leading], [data-title], [data-subtitle], [data-trailing]");

    // Her elemanı işle
    elements.forEach(el => {
        // Elin hangi data attribute'a sahip olduğunu bul
        const attrs = el.getAttributeNames().filter(a => a.startsWith("data-"));

        attrs.forEach(attr => {

            const key = el.getAttribute(attr);
            if (attr == "data-leading" && item[key]) {
                el.innerHTML = `<img src='${option.file_url}/${item[key]}' class='w-10 h-10 rounded-full object-cover'  />`;
            }   // örn: "sort", "model", "plate"
            else if (attr == "data-link" && item[key]) {
                el.href = `${option.url}/${item[key]}`;
            }   // örn: "sort", "model", "plate"
            else if (item[key]) {
                el.textContent = item[key] != null ? $t(`${item[key]}`) : "";     // içeriğini güncelle
            }
        });
    });

    return doc.body.innerHTML;
}

const selectValue = () => {
    let value = null;

    if (['Select', 'RadioButton', 'ListBox', 'InputCountry', 'MultiSelect', 'Typeahead', 'SelectButton'].includes(input.type)) {

        let options = collect(input.options);
        if (input.optionLabel && input.optionValue && !['MultiSelect', 'Typeahead'].includes(input.type)) {
            let item = options.where(input.optionValue, `${props.value}`).first();

            if (item) {
                let object = input.optionLabel.split('.');
                if (object.length > 1) {
                    value = item[object[0]][object[1]];
                } else {
                    value = item[input.optionLabel];
                }
            } else {
                value = props.value;
            }
        } else if (['MultiSelect', 'Typeahead'].includes(input.type)) {

            if (input.optionLabel && input.optionValue) {
                let values = options.whereIn(input.optionValue, props.value);
                value = collect(values.all()).pluck(input.optionLabel).implode(', ');
            } else {
                value = collect(props.value).implode(', ');
            }



        }


    }

    return value
}


</script>

<style>
.currency {
    display: flex;
    align-items: center;
    justify-content: start;
    height: 50px;
}

.currency .p-inputnumber .p-inputtext {
    width: 100%;
    border: none !important;
    border-color: transparent !important;
    box-shadow: none !important;
    background: transparent !important;
}

@media screen and (max-width: 1024px) {
    .currency .p-inputnumber .p-inputtext {
        text-align: end !important;
    }

}
</style>
